import { render } from "./OverdueList.vue?vue&type=template&id=63767700&scoped=true"
import script from "./OverdueList.vue?vue&type=script&lang=js"
export * from "./OverdueList.vue?vue&type=script&lang=js"

import "./OverdueList.vue?vue&type=style&index=0&id=63767700&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63767700"]])

export default __exports__